"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var AcceptersDataStore_1 = require("./AcceptersDataStore");
var AcceptFlowGlobalRegistry = (function () {
    function AcceptFlowGlobalRegistry() {
        this.dataStoreInstances = [];
    }
    AcceptFlowGlobalRegistry.getInstance = function () {
        if (!AcceptFlowGlobalRegistry.instance) {
            AcceptFlowGlobalRegistry.instance = new AcceptFlowGlobalRegistry();
        }
        return AcceptFlowGlobalRegistry.instance;
    };
    AcceptFlowGlobalRegistry.prototype.getDataStoreInstance = function (id) {
        return this.dataStoreInstances.find(function (store) { return store.id === id; });
    };
    AcceptFlowGlobalRegistry.prototype.registerDataStore = function (instance, storeId) {
        var matchingInstance = this.dataStoreInstances.find(function (storeInstance) { return storeInstance.id === instance.id; });
        if (!matchingInstance) {
            instance.setStoreId(storeId);
            this.dataStoreInstances.push(instance);
        }
    };
    AcceptFlowGlobalRegistry.prototype.getAllDataStores = function () {
        return this.dataStoreInstances;
    };
    AcceptFlowGlobalRegistry.prototype.clear = function () {
        this.dataStoreInstances = [];
    };
    AcceptFlowGlobalRegistry.prototype.getLastFilledIndex = function () {
        if (this.dataStoreInstances.length === 0) {
            return null;
        }
        var lastIndex = -1;
        var hasFilledSlots = false;
        this.dataStoreInstances.forEach(function (store) {
            if (store.accepterIndex !== null && store.accepterIndex > lastIndex) {
                lastIndex = store.accepterIndex;
                hasFilledSlots = true;
            }
        });
        return hasFilledSlots ? lastIndex : null;
    };
    AcceptFlowGlobalRegistry.prototype.isSlotFilledInAllStores = function (index) {
        if (this.dataStoreInstances.length === 0)
            return true;
        if (index === null)
            return undefined;
        return this.dataStoreInstances.every(function (store) {
            var slot = store === null || store === void 0 ? void 0 : store.accepterSlots[index];
            return slot && ((slot.initials && slot.initials !== "") || (slot.signature && slot.signature !== ""));
        });
    };
    AcceptFlowGlobalRegistry.prototype.areAllSlotsFilled = function () {
        if (this.dataStoreInstances.length === 0)
            return true;
        var lastIndex = this.getLastFilledIndex();
        if (lastIndex === null)
            return false;
        for (var i = 0; i <= lastIndex; i++) {
            if (!this.isSlotFilledInAllStores(i)) {
                return false;
            }
        }
        return true;
    };
    AcceptFlowGlobalRegistry.prototype.isSlotLockedInAnyStore = function (index) {
        return this.dataStoreInstances.some(function (store) { return store.isSlotLocked(index); });
    };
    AcceptFlowGlobalRegistry.prototype.getInitialsForSlot = function (index) {
        var _a;
        var store = this.dataStoreInstances.find(function (store) {
            var slot = store === null || store === void 0 ? void 0 : store.accepterSlots[index];
            return slot && slot.initials;
        });
        if (!store) {
            return undefined;
        }
        if (store.accepterSlots[index]) {
            return (_a = store.accepterSlots[index]) === null || _a === void 0 ? void 0 : _a.initials;
        }
        return undefined;
    };
    AcceptFlowGlobalRegistry.prototype.getPrefilledNameForSlot = function (index) {
        var store = this.dataStoreInstances.find(function (store) {
            var slot = store === null || store === void 0 ? void 0 : store.accepterSlots[index];
            return slot && slot.name;
        });
        if (!store) {
            return;
        }
        var slot = store.accepterSlots[index];
        if (slot && store.hasPrefilledName(index)) {
            return slot.name;
        }
        return;
    };
    AcceptFlowGlobalRegistry.prototype.findFirstMissingSignature = function (slotposition) {
        var _a, _b, _c;
        var missingSignatures = [];
        for (var i = 0; i < this.dataStoreInstances.length; i++) {
            if (((_a = this.dataStoreInstances[i]) === null || _a === void 0 ? void 0 : _a.accepterIndex) === null) {
                var store = this.dataStoreInstances[i];
                if (!store) {
                    continue;
                }
                if (store.accepterSlots[slotposition] &&
                    (!((_b = store.accepterSlots[slotposition]) === null || _b === void 0 ? void 0 : _b.signature) || !((_c = store.accepterSlots[slotposition]) === null || _c === void 0 ? void 0 : _c.initials))) {
                    var slot = store.accepterSlots[slotposition];
                    if (slot) {
                        slot.isCritical = true;
                    }
                    missingSignatures.push({ storeIndex: i, slotIndex: slotposition });
                }
            }
        }
        return missingSignatures.length > 0 && missingSignatures[0]
            ? { storeIndex: missingSignatures[0].storeIndex, slotIndex: missingSignatures[0].slotIndex }
            : null;
    };
    AcceptFlowGlobalRegistry.prototype.findAllMissingSignatures = function () {
        var _a, _b;
        var missingSignatures = [];
        for (var i = 0; i < this.dataStoreInstances.length; i++) {
            var store = this.dataStoreInstances[i];
            if (!store || store.accepterIndex !== null) {
                continue;
            }
            for (var slotIndex = 0; slotIndex < store.accepterSlots.length; slotIndex++) {
                if (store.accepterSlots[slotIndex] &&
                    (!((_a = store.accepterSlots[slotIndex]) === null || _a === void 0 ? void 0 : _a.signature) || !((_b = store.accepterSlots[slotIndex]) === null || _b === void 0 ? void 0 : _b.initials))) {
                    missingSignatures.push({ storeIndex: i, slotIndex: slotIndex });
                    var slot = store.accepterSlots[slotIndex];
                    if (slot) {
                        slot.isCritical = true;
                    }
                }
            }
        }
        return missingSignatures;
    };
    AcceptFlowGlobalRegistry.prototype.resetAllCriticalFlags = function () {
        for (var i = 0; i < this.dataStoreInstances.length; i++) {
            var store = this.dataStoreInstances[i];
            if (!store) {
                continue;
            }
            for (var slotIndex = 0; slotIndex < store.accepterSlots.length; slotIndex++) {
                var slot = store.accepterSlots[slotIndex];
                if (slot) {
                    slot.isCritical = false;
                }
            }
        }
    };
    AcceptFlowGlobalRegistry.prototype.copySignatureFromOtherStores = function (index, currentStore) {
        var e_1, _a;
        var _b;
        if (!currentStore.accepterSlots[index]) {
            return;
        }
        var hasSignature = !!((_b = currentStore.accepterSlots[index]) === null || _b === void 0 ? void 0 : _b.signature);
        if (hasSignature) {
            return;
        }
        try {
            for (var _c = __values(this.dataStoreInstances), _d = _c.next(); !_d.done; _d = _c.next()) {
                var store = _d.value;
                if (store === currentStore || !(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                var slot = store.accepterSlots[index];
                if (!slot) {
                    continue;
                }
                if (slot.signature) {
                    currentStore.updateSlotSignature(index, slot.signature, slot.signatureMethod);
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AcceptFlowGlobalRegistry.prototype.copyInitialsFromOtherStores = function (index, currentStore) {
        var e_2, _a;
        var _b;
        if (!currentStore.accepterSlots[index]) {
            return;
        }
        var hasInitials = !!((_b = currentStore.accepterSlots[index]) === null || _b === void 0 ? void 0 : _b.initials);
        if (hasInitials) {
            return;
        }
        try {
            for (var _c = __values(this.dataStoreInstances), _d = _c.next(); !_d.done; _d = _c.next()) {
                var store = _d.value;
                if (store === currentStore || !(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                var slot = store.accepterSlots[index];
                if (!slot) {
                    continue;
                }
                if (slot.initials) {
                    currentStore.updateSlotInitials(index, slot.initials, slot.initialsMethod);
                    return;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    AcceptFlowGlobalRegistry.prototype.clearAllInitialsAtIndex = function (index) {
        var e_3, _a;
        try {
            for (var _b = __values(this.dataStoreInstances), _c = _b.next(); !_c.done; _c = _b.next()) {
                var store = _c.value;
                if (!(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                store.clearInitials(index);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    AcceptFlowGlobalRegistry.prototype.clearAllSignaturesAtIndex = function (index) {
        var e_4, _a;
        try {
            for (var _b = __values(this.dataStoreInstances), _c = _b.next(); !_c.done; _c = _b.next()) {
                var store = _c.value;
                if (!(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                store.clearSignature(index);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    AcceptFlowGlobalRegistry.prototype.setName = function (index, name) {
        var e_5, _a;
        try {
            for (var _b = __values(this.dataStoreInstances), _c = _b.next(); !_c.done; _c = _b.next()) {
                var store = _c.value;
                if (!(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                store.updateSlotName(index, name);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    AcceptFlowGlobalRegistry.prototype.isSlotFilledInAnyStore = function (index, type) {
        var e_6, _a;
        var _b, _c;
        try {
            for (var _d = __values(this.dataStoreInstances), _e = _d.next(); !_e.done; _e = _d.next()) {
                var store = _e.value;
                if (!(store === null || store === void 0 ? void 0 : store.accepterSlots[index])) {
                    continue;
                }
                if ((!!((_b = store.accepterSlots[index]) === null || _b === void 0 ? void 0 : _b.signature) && type === "signature") ||
                    (!!((_c = store.accepterSlots[index]) === null || _c === void 0 ? void 0 : _c.initials) && type === "initials")) {
                    return true;
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return false;
    };
    Object.defineProperty(AcceptFlowGlobalRegistry.prototype, "currentSlot", {
        get: function () {
            var _a;
            var storeWithAccepter = this.dataStoreInstances.find(function (store) { return store.accepterIndex !== null; });
            return (_a = storeWithAccepter === null || storeWithAccepter === void 0 ? void 0 : storeWithAccepter.accepterIndex) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AcceptFlowGlobalRegistry.prototype, "dataStoreInstances", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof AcceptersDataStore_1.AcceptersDataStore !== "undefined" && AcceptersDataStore_1.AcceptersDataStore) === "function" ? _a : Object, String]),
        __metadata("design:returntype", void 0)
    ], AcceptFlowGlobalRegistry.prototype, "registerDataStore", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AcceptFlowGlobalRegistry.prototype, "clear", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AcceptFlowGlobalRegistry.prototype, "resetAllCriticalFlags", null);
    return AcceptFlowGlobalRegistry;
}());
exports.default = AcceptFlowGlobalRegistry;
